import { convertToString, convertToStringObject } from "./convertToString";

export default function payloadToUrl(router: any, payload: any) {
  // console.log("check here payload:", payload);
  let urlQuery: any = {};
  let urlString: string = "auction-properties";
  // `${data.asset_type}-${data.sub_asset_type}-auction-properties-in-${data.city}-${data.state}-by-${data.bank}`
  if (payload?.asset_type) {
    if (!urlQuery.start_from) {
      urlQuery["start_from"] = "asset-type";
    }

    // Get the asset_type value
    const assetTypeValue = payload.asset_type.value || "";

    if (payload.sub_asset_type) {
      // Only append if sub_asset_type has a valid value
      const subAssetValue = Array.isArray(payload.sub_asset_type)
        ? payload.sub_asset_type[0]?.value || ""
        : payload.sub_asset_type.value || "";

      if (subAssetValue) {
        urlString = `${assetTypeValue}-${subAssetValue}-${urlString}`;
      } else {
        urlString = `${assetTypeValue}-${urlString}`;
      }
    } else {
      urlString = `${assetTypeValue}-${urlString}`;
    }
  } else if (payload?.sub_asset_type) {
    const subAssetValue = Array.isArray(payload.sub_asset_type)
      ? payload.sub_asset_type[0]?.value || ""
      : payload.sub_asset_type.value || "";

    if (subAssetValue) {
      urlString = `${subAssetValue}-${urlString}`;
    }
  }

  // if (payload.state && payload.city && payload.locality) {
  //   if (!urlQuery.start_from) {
  //     urlQuery["start_from"] = "location";
  //   }
  //   urlString =
  //     urlString +
  //     `-in-${payload.locality[0].value}-${payload.city.value}-${payload.state.value}`;
  // } else if (payload.state) {
  //   if (!urlQuery.start_from) {
  //     urlQuery["start_from"] = "location";
  //   }
  //   urlString = urlString + `-in-${payload.state.value}`;
  // } else if (payload.city) {
  //   urlString = urlString + `-in-${payload.city.value}`;
  // } else if (payload.locality) {
  //   urlString = urlString + `-in-${payload.locality[0].value}`;
  // }

  const locationParts: string[] = [];
  if (payload.locality && payload.locality.length > 0) {
    locationParts.push(payload.locality[0].value);
  }
  if (payload?.city?.value) {
    locationParts.push(payload.city.value);
  }
  if (payload.state) {
    locationParts.push(payload.state.value);
  }

  if (locationParts.length > 0) {
    if (!urlQuery.start_from) {
      urlQuery["start_from"] = "location";
    }
    urlString += `-in-${locationParts.join("-")}`;
  }
  if (payload?.institutes?.length > 0) {
    urlString = urlString + `-by-${payload.institutes[0].value}`;
  }

  if (payload.reserve_price) {
    // console.log("reserve price payloadToUrl.ts ----------------------------");
    urlQuery["reserve_price"] = payload.reserve_price;
  }
  if (payload.sort_by) {
    urlQuery["sort_by"] = payload.sort_by.value;
  }
  if (payload.filter_by) {
    urlQuery["filter_by"] = payload.filter_by.value;
  }
  if (payload.auction_start_date_unix_timestamp) {
    // console.log(
    //   "auction_start_date_unix_timestamp payloadToUrl.ts ----------------------------"
    // );
    urlQuery["auction_start_date_unix_timestamp"] =
      payload.auction_start_date_unix_timestamp;
  }

  // console.log("url query ===> ", urlQuery)
  // console.log("url string ====> ", urlString)
  router.push(
    {
      pathname: `/${urlString}`,
      query: urlQuery,
    },
    undefined,
    { shallow: true }
  );
}
